import React from 'react';
import { Toggle } from 'components/Toggle';
import { actionDisplayNames } from '../ClaimAutomation/utils';

const getActionBadge = (action: string, refundShipping?: boolean) => {
  const label =
    (actionDisplayNames as Record<string, string>)[action] || action;
  switch (action) {
    case 'REFUND':
      return (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
          <span>{label}</span>
          {refundShipping && (
            <span className="text-[10px] font-bold bg-emerald-200 text-emerald-800 px-1.5 py-0.2 rounded">
              + Shipping
            </span>
          )}
        </span>
      );
    case 'REORDER':
      return (
        <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-200">
          {label}
        </span>
      );
    case 'STORE_CREDIT':
      return (
        <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-purple-50 text-purple-700 border border-purple-200">
          {label}
        </span>
      );
    case 'DENY':
      return (
        <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-rose-50 text-rose-700 border border-rose-200">
          {label}
        </span>
      );
    default:
      return (
        <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-slate-50 text-slate-700 border border-slate-200">
          {label}
        </span>
      );
  }
};

export const columns = [
  {
    name: 'Rule',
    id: 1,
    render: (item: any) => {
      const priorityDisplay =
        item.priority ?? (item.index !== undefined ? item.index + 1 : 1);
      return (
        <div className="py-1 pl-10 text-left">
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center px-2 py-0.5 text-xs font-bold rounded bg-slate-100 text-slate-600 border border-slate-200">
              #{priorityDisplay}
            </span>
            <span className="font-semibold text-slate-900 text-sm">
              {item.title}
            </span>
          </div>
          {item.ruleSummary && (
            <p className="text-xs text-slate-500 mt-1 max-w-md font-normal leading-relaxed">
              {item.ruleSummary}
            </p>
          )}
        </div>
      );
    },
  },
  {
    name: 'Resolution Action',
    id: 2,
    render: (item: any) => getActionBadge(item.action, item.refundShipping),
  },
  {
    name: 'Status',
    id: 4,
    render: (item: any) => {
      return (
        <div className="flex items-center gap-2">
          <Toggle
            disabled={item.busy}
            ariaLabel={`Active rule: ${item.title}`}
            isEnabled={Boolean(item.active)}
            onChange={item.updateRuleStatus}
            isSmall
          />
          <span className="text-xs font-medium text-slate-600">
            {item.active ? 'Active' : 'Paused'}
          </span>
        </div>
      );
    },
  },
  {
    name: 'Actions',
    id: 5,
    render: (item: any) => {
      return (
        <div className="flex items-center gap-1.5">
          <button
            type="button"
            disabled={item.busy}
            onClick={item.editRule}
            className="px-2.5 py-1 rounded-md text-xs font-medium text-slate-700 border border-slate-300 hover:bg-slate-50 transition-colors shadow-2xs"
          >
            Edit
          </button>
          {item.cloneRule && (
            <button
              type="button"
              disabled={item.busy}
              onClick={item.cloneRule}
              className="px-2.5 py-1 rounded-md text-xs font-medium text-blue-700 border border-blue-200 bg-blue-50/50 hover:bg-blue-100/70 transition-colors shadow-2xs"
            >
              Clone
            </button>
          )}
          <button
            type="button"
            disabled={item.busy}
            onClick={item.deleteRule}
            className="px-2.5 py-1 rounded-md text-xs font-medium text-red-600 border border-red-200 hover:bg-red-50 transition-colors shadow-2xs"
          >
            Delete
          </button>
        </div>
      );
    },
  },
];
